import React from 'react'
import { navigate } from '@reach/router'
import { makeStyles } from '@material-ui/styles'
import { Typography } from '@material-ui/core'
import qs from 'qs'
import { Page } from 'components'
import Results from './Results'
import SearchBar from './SearchBar'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  results: {
    marginTop: theme.spacing(3),
  },
}))

const Activities = (props) => {
  const { location } = props
  location.period = 0

  const classes = useStyles()

  const handleFilter = (values) => {
    const queryParams = qs.parse(location.search, { ignoreQueryPrefix: true }) || {}
    const newParams = {
      ...queryParams,
      ...values,
      page: 0,
    }
    const newSearchString = qs.stringify(newParams)
    navigate(`/activities?${newSearchString}`)
  }

  const handleSearch = (value) => {
    const queryParams = qs.parse(location.search, { ignoreQueryPrefix: true }) || {}
    const newParams = {
      ...queryParams,
      search: value,
    }
    const newSearchString = qs.stringify(newParams)
    navigate(`/activities?${newSearchString}`)
  }

  const handleReset = () => {
    navigate(`/activities`)
  }

  return (
    <Page className={classes.root} title="Aktivitet">
      <Typography component="h1" variant="h3" gutterBottom>
        Aktivitet
      </Typography>
      <SearchBar
        location={location}
        onFilter={handleFilter}
        onSearch={handleSearch}
        handleReset={handleReset}
      />
      <Results className={classes.results} location={location} />
    </Page>
  )
}

export default Activities
